import template from './uc-theme-picker.html.twig';
import './uc-theme-picker.scss';

Shopware.Component.register('uc-theme-picker', {
    template,

    props: {
        value: {
            type: String,
            default: 'classic',
        },
    },

    emits: ['update:value'],

    data() {
        return {
            themes: [
                {
                    key: 'classic',
                    icon: '✦',
                    preview: ['#ffffff', '#f9fafb', '#0f69c4'],
                },
                {
                    key: 'bold',
                    icon: '◼',
                    preview: ['#111827', '#374151', '#0f69c4'],
                },
                {
                    key: 'soft',
                    icon: '◉',
                    preview: ['#fef9f4', '#f0e8df', '#c084fc'],
                },
            ],
        };
    },

    methods: {
        select(key) {
            this.$emit('update:value', key);
        },

        label(key) {
            return this.$tc(`sellops-ultimate-cart.theme.${key}.label`);
        },

        desc(key) {
            return this.$tc(`sellops-ultimate-cart.theme.${key}.desc`);
        },
    },
});
